export const prethrowError = <T>(error: T): T => {
  try {
    throw error;
  } catch (e) {
    return e as any;
  }
};
